(function () {
  'use strict';
  var MAX = 3, TAP_MIN = 1.6, TAP_MAX = 2, KEY_STEP = 1.25, PAN_STEP = 60;
  var SPRING_MS = 260, DRAG = 6, DOUBLE_MS = 300, DOUBLE_PX = 30;
  var PROXY = /\/width:(\d+)\//;
  var SHARP_W = 1600;
  var GATE = 1.5;
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var finePointer = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;

  function tok(name, fallback) {
    var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return v || fallback;
  }
  var EASE = tok('--sp-ease-out', 'cubic-bezier(0.22, 1, 0.36, 1)');
  var DUR = tok('--sp-dur-3', '320ms');

  var bg = null;
  var img = null;
  var s = 1, tx = 0, ty = 0;
  var geo = null;
  var raf = 0;
  var glide = 0;
  var pointers = new Map();
  var gesture = null;
  var lastTap = null;
  var swiperHeld = false;
  var btn = null;

  function stage() { return bg && bg.querySelector('.kl_reviews__lightbox__left'); }
  function swiper() {
    var el = bg && bg.querySelector('.kl_reviews__lightbox__left .swiper');
    return el && el.swiper;
  }
  function activeImg() {
    if (!bg) return null;
    var slide = bg.querySelector('.kl_reviews__lightbox__left .swiper-slide-active');
    if (!slide || slide.querySelector('video')) return null;
    return slide.querySelector('.kl_reviews__gallery_lightbox_thumbnail_container img');
  }
  function measure(el) {
    var W = el.offsetWidth, H = el.offsetHeight;
    var nw = el.naturalWidth || W, nh = el.naturalHeight || H;
    var k = Math.min(W / nw, H / nh);
    var fr = el.hasAttribute('data-sp-kr-fill') && el.closest('.swiper-slide');
    if (fr) { W = Math.min(W, fr.clientWidth); H = Math.min(H, fr.clientHeight); }
    var r = el.getBoundingClientRect();
    var cx = r.left + r.width / 2 - tx, cy = r.top + r.height / 2 - ty;
    return { W: W, H: H, w: nw * k, h: nh * k, cx: cx, cy: cy };
  }

  function limits(scale) {
    return {
      x: Math.max(0, (geo.w * scale - geo.W) / 2),
      y: Math.max(0, (geo.h * scale - geo.H) / 2)
    };
  }
  function clampTo(scale, x, y) {
    var L = limits(scale);
    return { x: Math.max(-L.x, Math.min(L.x, x)), y: Math.max(-L.y, Math.min(L.y, y)) };
  }
  function rubber(v, lim) {
    if (v > lim) return lim + (v - lim) * 0.35 / (1 + (v - lim) / 400);
    if (v < -lim) return -lim + (v + lim) * 0.35 / (1 + (-lim - v) / 400);
    return v;
  }

  function write() {
    raf = 0;
    if (!img) return;
    img.style.transform = 'translate3d(' + tx.toFixed(2) + 'px,' + ty.toFixed(2) + 'px,0) scale(' + s.toFixed(4) + ')';
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(write); }

  function animated(ms) {
    if (!img) return;
    var still = reduce && reduce.matches;
    img.style.transition = still ? 'none' : 'transform ' + (ms ? ms + 'ms' : DUR) + ' ' + EASE;
  }
  function live() { if (img) img.style.transition = 'none'; }

  function setZoomed(on) {
    if (!bg) return;
    bg.classList.toggle('sp-kr-zoomed', on);
    if (img) img.style.willChange = on ? 'transform' : '';
    if (btn) {
      btn.setAttribute('aria-pressed', String(on));
      btn.setAttribute('aria-label', on ? 'Zoom out' : 'Zoom in');
    }
    holdSwiper(on);
    if (on) sharpen();
  }

  function holdSwiper(on) {
    var sw = swiper();
    if (!sw) return;
    if (on && !swiperHeld) { swiperHeld = true; sw.allowTouchMove = false; }
    else if (!on && swiperHeld) { swiperHeld = false; sw.allowTouchMove = true; }
  }
  function zoomAt(to, px, py, smooth) {
    if (!img) return;
    if (!zoomable(img)) return;
    if (!geo) geo = measure(img);
    to = Math.max(1, Math.min(cap(img), to));
    var ox = px - geo.cx, oy = py - geo.cy;
    var nx = ox - (ox - tx) * (to / s), ny = oy - (oy - ty) * (to / s);
    var c = clampTo(to, nx, ny);
    s = to; tx = to === 1 ? 0 : c.x; ty = to === 1 ? 0 : c.y;
    if (smooth) animated(); else live();
    schedule();
    setZoomed(s > 1.001);
  }

  function reset(smooth) {
    stopGlide();
    if (!img) { s = 1; tx = ty = 0; return; }
    if (s === 1 && tx === 0 && ty === 0) { setZoomed(false); return; }
    s = 1; tx = 0; ty = 0;
    if (smooth) animated(); else live();
    schedule();
    setZoomed(false);
  }

  function springBack() {
    if (!geo) return;
    var c = clampTo(s, tx, ty);
    if (c.x === tx && c.y === ty) return;
    tx = c.x; ty = c.y;
    animated(SPRING_MS);
    schedule();
  }

  function stopGlide() { if (glide) { cancelAnimationFrame(glide); glide = 0; } }
  function startGlide(vx, vy) {
    if (reduce && reduce.matches) { springBack(); return; }
    if (Math.hypot(vx, vy) < 0.05) { springBack(); return; }
    live();
    var last = performance.now();
    var step = function (now) {
      var dt = Math.min(32, now - last); last = now;
      var f = Math.pow(0.95, dt / 16);
      vx *= f; vy *= f;
      tx += vx * dt; ty += vy * dt;
      var L = limits(s);
      var hit = false;
      if (tx > L.x || tx < -L.x) { vx = 0; hit = true; }
      if (ty > L.y || ty < -L.y) { vy = 0; hit = true; }
      write();
      if (Math.hypot(vx, vy) < 0.02 || hit) { glide = 0; springBack(); return; }
      glide = requestAnimationFrame(step);
    };
    glide = requestAnimationFrame(step);
  }

  function sharpen() {
    if (!img || img.__spKrZoomSharp) return;
    var src = img.getAttribute('src') || '';
    if (img.__spKrSharp) {
      img.__spKrZoomSharp = true;
      var t0 = img, u0 = img.__spKrSharp, p0 = new Image();
      var d0 = function () { if (t0.getAttribute('src') === src) t0.setAttribute('src', u0); };
      p0.src = u0;
      if (p0.decode) p0.decode().then(d0, function () {}); else p0.onload = d0;
      return;
    }
    var m = src.match(PROXY);
    if (!m || Number(m[1]) >= SHARP_W) { img.__spKrZoomSharp = true; return; }
    img.__spKrZoomSharp = true;
    var target = img, to = src.replace(PROXY, '/width:' + SHARP_W + '/');
    var pre = new Image();
    var done = function () { if (target.getAttribute('src') === src) target.setAttribute('src', to); };
    pre.src = to;
    if (pre.decode) pre.decode().then(done, function () {}); else pre.onload = done;
  }
  function onPhoto(e) {
    var a = activeImg();
    if (!a || e.target !== a) return false;
    var g = measure(a);
    var x = e.clientX, y = e.clientY;
    var hw = (s > 1.001 ? Math.min(g.W, g.w * s) : g.w) / 2, hh = (s > 1.001 ? Math.min(g.H, g.h * s) : g.h) / 2;
    return Math.abs(x - g.cx) <= hw && Math.abs(y - g.cy) <= hh;
  }

  function density() { return Math.min(window.devicePixelRatio || 1, 2); }
  function cap(el) {
    if (!el || !el.__spKrSrcW || !el.__spKrDrawnW) return 0;
    var c = el.__spKrSrcW / (el.__spKrDrawnW * density());
    return c >= GATE ? Math.min(MAX, c) : 1;
  }
  function zoomable(el) { return cap(el) > 1; }
  function tapLevel(el) {
    var g = measure(el);
    var fill = Math.max(g.W / g.w, g.H / g.h) || TAP_MIN;
    return Math.min(Math.max(TAP_MIN, Math.min(TAP_MAX, fill)), cap(el));
  }

  function probeSource(el) {
    if (!el || el.__spKrProbe) return;
    var g = measure(el);
    el.__spKrDrawnW = g.w;
    var src = el.getAttribute('src') || '';
    var need = Math.ceil(g.w * density() * GATE);
    var m = src.match(PROXY);
    el.__spKrProbe = true;
    if (!m) { el.__spKrSrcW = el.naturalWidth || 0; gate(); return; }
    var ask = Math.min(2400, Math.max(need, Math.ceil(g.w * density() * MAX / 160) * 160));
    var u = src.replace(PROXY, '/width:' + ask + '/');
    var pre = new Image();
    pre.onload = function () {
      if (el.naturalWidth) el.__spKrDrawnW = measure(el).w;
      el.__spKrSrcW = Math.max(pre.naturalWidth, el.naturalWidth || 0);
      el.__spKrSharp = pre.naturalWidth > (el.naturalWidth || 0) ? u : null;
      if (el === img) gate();
    };
    pre.onerror = function () { el.__spKrSrcW = el.naturalWidth || 0; if (el === img) gate(); };
    var go = function () { try { pre.fetchPriority = 'low'; } catch (e) {} pre.src = u; };
    var idle = function () { if (window.requestIdleCallback) requestIdleCallback(go, { timeout: 2500 }); else setTimeout(go, 400); };
    if (el.complete && el.naturalWidth) idle(); else el.addEventListener('load', idle, { once: true });
  }
  var HIDE_DELAY = 220, hideT = 0;
  function gate() {
    if (!bg) return;
    var known = img && cap(img) > 0;
    var ok = img && zoomable(img);
    if (img && !known && !ok) return;
    bg.classList.toggle('sp-kr-nozoom', !ok);
    if (!btn) return;
    clearTimeout(hideT);
    if (ok) { btn.removeAttribute('aria-disabled'); btn.removeAttribute('title'); return; }
    var b = btn;
    hideT = setTimeout(function () {
      b.setAttribute('aria-disabled', 'true');
      if (known) b.setAttribute('title', 'Photo is too small to zoom'); else b.removeAttribute('title');
    }, b.hasAttribute('aria-disabled') ? 0 : HIDE_DELAY);
  }

  function ensureImg() {
    var a = activeImg();
    if (a !== img) {
      if (img) { img.style.transform = ''; img.style.transition = ''; img.style.willChange = ''; }
      img = a; s = 1; tx = ty = 0; geo = null;
      setZoomed(false);
      if (img) probeSource(img);
      gate();
    }
    return img;
  }

  function down(e) {
    if (!bg || !ensureImg()) return;
    var st = stage();
    if (!st || !st.contains(e.target)) return;
    if (e.target.closest('button, a, .sp-kr-strip, .sp-kr-vbar')) return;
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY, t: performance.now(), type: e.pointerType });
    stopGlide();
    if (pointers.size === 2) {
      var sw = swiper();
      if (sw && !swiperHeld) { holdSwiper(true); try { sw.slideTo(sw.activeIndex, 0); } catch (err) {} }
      geo = measure(img);
      var p = Array.from(pointers.values());
      gesture = { kind: 'pinch', d0: Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y) || 1, s0: s, tx0: tx, ty0: ty,
        mx0: (p[0].x + p[1].x) / 2, my0: (p[0].y + p[1].y) / 2 };
      live();
      img.style.willChange = 'transform';
      e.preventDefault();
      return;
    }
    if (pointers.size === 1 && s > 1.001 && e.target === img) {
      geo = measure(img);
      gesture = { kind: 'pan', x0: e.clientX, y0: e.clientY, tx0: tx, ty0: ty, moved: false, hist: [{ x: e.clientX, y: e.clientY, t: performance.now() }] };
      try { img.setPointerCapture(e.pointerId); } catch (err) {}
      live();
      e.stopPropagation();
      if (e.pointerType === 'mouse') e.preventDefault();
    }
  }

  function move(e) {
    var p = pointers.get(e.pointerId);
    if (!p || !gesture) return;
    p.x = e.clientX; p.y = e.clientY;
    if (gesture.kind === 'pinch' && pointers.size >= 2) {
      var q = Array.from(pointers.values());
      var d = Math.hypot(q[0].x - q[1].x, q[0].y - q[1].y);
      var mx = (q[0].x + q[1].x) / 2, my = (q[0].y + q[1].y) / 2;
      var raw = gesture.s0 * d / gesture.d0;
      var top = zoomable(img) ? cap(img) : 1;
      var ns = raw < 1 ? 1 - (1 - raw) * 0.4 : raw > top ? top + Math.min(top === 1 ? 0.05 : 1, (raw - top) * 0.25) : raw;
      var ox = gesture.mx0 - geo.cx, oy = gesture.my0 - geo.cy;
      tx = ox - (ox - gesture.tx0) * (ns / gesture.s0) + (mx - gesture.mx0);
      ty = oy - (oy - gesture.ty0) * (ns / gesture.s0) + (my - gesture.my0);
      s = ns;
      schedule();
      e.preventDefault();
    } else if (gesture.kind === 'pan') {
      var dx = e.clientX - gesture.x0, dy = e.clientY - gesture.y0;
      if (!gesture.moved && Math.abs(dx) + Math.abs(dy) > DRAG) { gesture.moved = true; bg.classList.add('sp-kr-panning'); }
      var L = limits(s);
      tx = rubber(gesture.tx0 + dx, L.x);
      ty = rubber(gesture.ty0 + dy, L.y);
      var now = performance.now();
      gesture.hist.push({ x: e.clientX, y: e.clientY, t: now });
      while (gesture.hist.length > 2 && now - gesture.hist[0].t > 100) gesture.hist.shift();
      schedule();
      e.preventDefault();
    }
  }

  function up(e) {
    var p = pointers.get(e.pointerId);
    if (!p) return;
    pointers.delete(e.pointerId);
    var g = gesture;
    if (g && g.kind === 'pinch') {
      if (pointers.size >= 1) {
        gesture = null;
        if (s < 1) { s = 1; tx = ty = 0; animated(SPRING_MS); schedule(); }
        if (s > (cap(img) || 1)) { s = Math.max(1, cap(img) || 1); if (s === 1) { tx = ty = 0; } animated(SPRING_MS); schedule(); }
        setZoomed(s > 1.001);
        if (s > 1.001) {
          var r = Array.from(pointers.values())[0];
          gesture = { kind: 'pan', x0: r.x, y0: r.y, tx0: tx, ty0: ty, moved: true, hist: [{ x: r.x, y: r.y, t: performance.now() }] };
        }
        return;
      }
      gesture = null;
      if (s < 1.02 || !zoomable(img)) { reset(true); return; }
      var to = Math.min(cap(img), s);
      var c = clampTo(to, tx, ty);
      s = to; tx = c.x; ty = c.y;
      animated(SPRING_MS); schedule();
      setZoomed(true);
      return;
    }
    if (g && g.kind === 'pan') {
      gesture = null;
      bg.classList.remove('sp-kr-panning');
      if (g.moved) {
        var h = g.hist, a = h[0], b = h[h.length - 1], dt = Math.max(1, b.t - a.t);
        var L = limits(s);
        if (Math.abs(tx) > L.x || Math.abs(ty) > L.y) springBack();
        else startGlide((b.x - a.x) / dt, (b.y - a.y) / dt);
        suppressClick = performance.now();
        return;
      }
    }
    gesture = null;
    if (e.pointerType === 'touch' && e.target === img) {
      var now = performance.now();
      if (lastTap && now - lastTap.t < DOUBLE_MS && Math.hypot(e.clientX - lastTap.x, e.clientY - lastTap.y) < DOUBLE_PX) {
        lastTap = null;
        geo = measure(img);
        if (s > 1.001) reset(true); else zoomAt(tapLevel(img), e.clientX, e.clientY, true);
        suppressClick = now;
      } else {
        lastTap = { t: now, x: e.clientX, y: e.clientY };
      }
    }
  }
  var suppressClick = 0;
  function click(e) {
    if (!bg || !bg.contains(e.target)) return;
    var st = stage();
    if (!st || !st.contains(e.target)) return;
    if (e.target.closest('button, a, .sp-kr-strip, .sp-kr-vbar, video')) return;
    if (!ensureImg()) return;
    var zoomed = s > 1.001;
    var on = onPhoto(e);
    if (!zoomed && !on) return;
    e.stopPropagation();
    e.preventDefault();
    if (performance.now() - suppressClick < 400) return;
    if (e.pointerType === 'touch' || (e.detail === 0 && !e.clientX)) return;
    if (!finePointer || !finePointer.matches) {
      return;
    }
    geo = measure(img);
    if (zoomed) { if (on) reset(true); else reset(true); }
    else zoomAt(tapLevel(img), e.clientX, e.clientY, true);
  }

  function dblclick(e) {
    if (!bg || !img || !stage() || !stage().contains(e.target)) return;
    if (performance.now() - suppressClick < 600) { e.stopPropagation(); return; }
    if (e.target.closest('button, a, .sp-kr-strip')) return;
    e.stopPropagation();
    reset(true);
  }

  function wheel(e) {
    if (!bg || !stage() || !stage().contains(e.target)) return;
    if (e.target.closest('.sp-kr-strip')) return;
    if (!ensureImg()) return;
    if (e.ctrlKey) {
      e.preventDefault();
      geo = geo || measure(img);
      var to = s * Math.exp(-e.deltaY * 0.01);
      zoomAt(to, e.clientX, e.clientY, false);
      if (to <= 1.001) reset(false);
      return;
    }
    if (s > 1.001) {
      e.preventDefault();
      geo = geo || measure(img);
      var c = clampTo(s, tx - e.deltaX, ty - e.deltaY);
      tx = c.x; ty = c.y; live(); schedule();
    }
  }

  function key(e) {
    if (!bg || !bg.isConnected) return;
    var t = e.target;
    if (t && t.matches && t.matches('input, textarea, select, [contenteditable="true"]')) return;
    if (!ensureImg()) return;
    var zoomed = s > 1.001;
    geo = measure(img);
    var cx = geo.cx, cy = geo.cy;
    if (e.key === 'Escape' && zoomed) { e.preventDefault(); e.stopImmediatePropagation(); reset(true); return; }
    if (e.key === '+' || e.key === '=') { e.preventDefault(); zoomAt(s * KEY_STEP, cx, cy, true); return; }
    if (e.key === '-' || e.key === '_') { e.preventDefault(); if (s / KEY_STEP <= 1.001) reset(true); else zoomAt(s / KEY_STEP, cx, cy, true); return; }
    if (e.key === '0' && zoomed) { e.preventDefault(); reset(true); return; }
    if (zoomed && /^Arrow/.test(e.key)) {
      e.preventDefault(); e.stopImmediatePropagation();
      var dx = e.key === 'ArrowLeft' ? PAN_STEP : e.key === 'ArrowRight' ? -PAN_STEP : 0;
      var dy = e.key === 'ArrowUp' ? PAN_STEP : e.key === 'ArrowDown' ? -PAN_STEP : 0;
      var c = clampTo(s, tx + dx, ty + dy);
      tx = c.x; ty = c.y; animated(SPRING_MS); schedule();
    }
  }

  function makeButton() {
    var st = stage();
    if (!st || st.querySelector(':scope > .sp-kr-zoom-btn')) return;
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sp-kr-zoom-btn';
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', 'Zoom in');
    btn.setAttribute('aria-disabled', 'true');
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (!ensureImg() || btn.getAttribute('aria-disabled') === 'true') return;
      geo = measure(img);
      if (s > 1.001) reset(true); else zoomAt(tapLevel(img), geo.cx, geo.cy, true);
    });
    st.appendChild(btn);
    placeButton();
    gate();
  }
  function placeButton() {
    var st = stage();
    if (!btn || !st) return;
    var host = btn.offsetParent;
    if (!host) return;
    var hr = host.getBoundingClientRect(), sr = st.getBoundingClientRect();
    var left = sr.right - hr.left - 12 - 44, top = sr.top - hr.top + 12;
    var x = bg.querySelector('.kl_reviews__close_button');
    if (x) {
      var xr = x.getBoundingClientRect();
      var bl = hr.left + left;
      if (bl < xr.right + 8 && bl + 44 > xr.left - 8 && hr.top + top < xr.bottom && hr.top + top + 44 > xr.top) left = xr.left - hr.left - 8 - 44;
    }
    btn.style.left = Math.round(left) + 'px';
    btn.style.top = Math.round(top) + 'px';
    btn.style.right = 'auto';
  }

  function syncVideo() {
    if (!bg) return;
    var slide = bg.querySelector('.kl_reviews__lightbox__left .swiper-slide-active');
    bg.classList.toggle('sp-kr-on-video', !!(slide && slide.querySelector('video')));
  }

  function attach(el) {
    bg = el;
    img = null; s = 1; tx = ty = 0; geo = null; swiperHeld = false; pointers.clear(); gesture = null;
    makeButton();
    syncVideo();
    ensureImg();
    var sw = swiper();
    if (sw && sw.on) sw.on('slideChange', function () { reset(false); ensureImg(); syncVideo(); });
    var mo = new MutationObserver(function () {
      if (!bg || !bg.isConnected) { mo.disconnect(); return; }
      makeButton();
      syncVideo();
      var a = activeImg();
      if (a !== img && !gesture) ensureImg();
      var s2 = swiper();
      if (s2 && s2.on && !s2.__spKrZoom) { s2.__spKrZoom = true; s2.on('slideChange', function () { reset(false); ensureImg(); syncVideo(); }); }
    });
    mo.observe(el, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true });
    if (sw) sw.__spKrZoom = true;
  }

  function detach() {
    stopGlide();
    bg = null; img = null; btn = null; pointers.clear(); gesture = null; swiperHeld = false;
  }

  new MutationObserver(function () {
    var el = document.querySelector('.kl_reviews__lightbox_background');
    if (el && el !== bg) attach(el);
    else if (!el && bg) detach();
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('touchmove', function (e) {
    if (!bg || e.touches.length < 2) return;
    var st = stage();
    if (st && st.contains(e.target) && e.cancelable) e.preventDefault();
  }, { capture: true, passive: false });
  document.addEventListener('pointerdown', down, { capture: true, passive: false });
  document.addEventListener('pointermove', move, { capture: true, passive: false });
  document.addEventListener('pointerup', up, true);
  document.addEventListener('pointercancel', up, true);
  document.addEventListener('click', click, true);
  document.addEventListener('dblclick', dblclick, true);
  document.addEventListener('wheel', wheel, { capture: true, passive: false });
  document.addEventListener('keydown', key, true);
  window.addEventListener('resize', function () { if (bg) { geo = null; reset(false); placeButton(); } });
})();
